module.exports = __webpack_public_path__ + "img/eden-escuelas-sin-reportar.2f8a184d.svg";